module.exports = __webpack_public_path__ + "12fdb50fed5f8cc3df152e0f7aed407d.png";